import React from 'react';
import { Link } from 'react-router-dom';

const NewsletterCta = () => {
    return (
        <section className="relative bg-gray-900 rounded-2xl my-20">
            {/* Background Image */}
            <img 
                src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?q=80&w=2084&auto=format&fit=crop"
                alt="Office background"
                className="absolute inset-0 w-full h-full object-cover rounded-2xl"
            />
            {/* Overlay */}
            <div className="absolute inset-0 bg-purple-900 opacity-80 rounded-2xl"></div>

            {/* Content */}
            <div className="relative container mx-auto px-4 py-24 text-center text-white">
                <h2 className="text-4xl md:text-5xl font-bold tracking-tight">
                    Get Career Tips Sent<br/>Directly To Your Inbox
                </h2>
                <p className="mt-4 text-lg text-purple-200">
                    Sign up for our weekly newsletter
                </p>
                
                <form className="mt-8 max-w-lg mx-auto">
                    <div className="flex items-center bg-white rounded-full p-2 shadow-lg">
                        <label htmlFor="email-address" className="sr-only">Email address</label>
                        <input
                            id="email-address"
                            name="email"
                            type="email"
                            autoComplete="email"
                            required
                            className="w-full bg-transparent text-gray-800 focus:outline-none px-4 py-2"
                            placeholder="Enter Your Email Address..."
                        />
                        <button
                            type="submit"
                            className="flex-shrink-0 bg-cyan-500 hover:bg-cyan-600 text-white font-bold py-3 px-6 rounded-full transition-colors"
                        >
                            Sign Up
                        </button>
                    </div>
                </form>

                <p className="mt-4 text-xs text-purple-300">
                    By signing up you're agreeing to our <Link to="/privacy-policy" className="underline hover:text-white">Privacy Policy</Link>
                </p>
            </div>
        </section>
    );
};

export default NewsletterCta; 